import { render, staticRenderFns } from "./Bgg_Weight.vue?vue&type=template&id=2492d26d&scoped=true"
import script from "./Bgg_Weight.vue?vue&type=script&lang=js"
export * from "./Bgg_Weight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2492d26d",
  null
  
)

export default component.exports